declare global {
  interface ImportMetaEnv {
    readonly VITE_API_BASE_URL?: string;
    readonly VITE_APP_NAME?: string;
    readonly VITE_BUILD_VERSION?: string;
  }

  interface ImportMeta {
    readonly env: ImportMetaEnv;
  }
}

export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || "/api/v1";
export const APP_NAME =
  import.meta.env.VITE_APP_NAME || "Meher Shop";
export const BUILD_VERSION =
  import.meta.env.VITE_BUILD_VERSION || "dev";

export const TOKEN_STORAGE_KEY = "autoclub.tokens";
export const CORRELATION_STORAGE_KEY = "autoclub.correlation";

export const PAYMENT_METHOD_LABELS: Record<string, string> = {
  mfs:           "Mobile Financial Services",
  bank_transfer: "Bank Transfer",
  cash_deposit:  "Cash Deposit",
  other:         "Other",
};

export const ENTRY_STATUS_META: Record<
  string,
  { label: string; tone: "info" | "success" | "warning" | "danger" | "neutral" }
> = {
  created:    { label: "Created",    tone: "info"    },
  placed:     { label: "Placed",     tone: "info"    },
  processing: { label: "Processing", tone: "warning" },
  completed:  { label: "Completed",  tone: "success" },
  archived:   { label: "Archived",   tone: "neutral" },
  inactive:   { label: "Inactive",   tone: "neutral" },
  blocked:    { label: "Blocked",    tone: "danger"  },
};
